export const STORAGE_PREFIX: string = 'storage_'
export const STORAGE_KEY_SESSIONDATA: string = 'sessionData'
export const STORAGE_KEY_LASTSESSION: string = 'lastSession'

export const LANGUAGE_STORAGE_KEY: string = 'settings.language'
export const LANGUAGE_DEFAULT_VALUE: string = 'ru'
export const TITLE_DEFAULT: string = 'Управление игровыми серверами'